<template>
    <b-modal
        v-model="isModalShown"
        @hide="onHide"
        @show="onShow"
        centered
        size="md"
        :title="title"
        hide-footer
        body-class="bg-gray-100"
    >
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <div class="min-height-300">
        <transition name="fade-fast" mode="out-in">
            <div v-if="mode == 'picker'" key="picker" class="d-flex justify-content-center align-items-center">
                <LoadingContext :loading="loadingSpecOptions" class="w-100">
                    <div class="row justify-content-around">
                        <div v-for="spec in specOptions" :key="spec.id" class="col-6 px-4 py-3 wf-starter-button-wrapper">
                            <b-button 
                                size="lg" 
                                variant="sharp-primary" 
                                @click="handleSpecSelection(spec)" 
                                class="w-100 h-100 min-height-80 wf-starter-button"
                            >
                                {{ spec.name }}
                            </b-button>
                        </div>
                    </div>
                </LoadingContext>
            </div>
            <div v-else-if="mode == 'form'" key="form" class="h-100">
                <LoadingContext :loading="loadingCreateSchema || loadingStart" class="d-flex flex-column h-100">
                    <!-- <div class="mb-3">
                        <b-link @click="onBack">&larr; Back</b-link>
                    </div> -->
                    <h4 class="mt-2 mb-4">{{ selectedSpec.name }}</h4>
                    <div v-if="createSchemaType == 'formulate'" class="h-100">
                        <FormulateForm
                            class="h-100"
                            name="createWorkflowRunForm"
                            v-model="createData"
                            :schema="createSchema"
                            #default="{ isLoading, hasErrors }"
                            @submit="onSave"
                        >
                            <div class="d-flex justify-content-between align-items-center mt-4">
                                <div class="">
                                    <b-link @click="onBack">&larr; Back</b-link>
                                </div>
                                <div class="d-flex">
                                    <CancelButton @cancel="onCancel" />
                                    <b-button
                                        variant="primary"
                                        size="lg"
                                        :disabled="loadingStart || showSuccess || isLoading || hasErrors"
                                        @click="submitForm"
                                    >Start</b-button>
                                    <!-- <SaveButton 
                                        :locked="loadingStart || showSuccess || isLoading || hasErrors" 
                                        @save="submitForm" 
                                    /> -->
                                </div>
                            </div>
                        </FormulateForm>
                    </div>
                    <!-- <div class="d-flex">
                        <pre>{{ createSchema }}</pre>
                    </div> -->
                    
                </LoadingContext>
            </div>
            <div v-else-if="mode == 'success'" key="success" class="h-100">
                <save-success message="Redirecting to next step..."></save-success>
            </div>
        </transition>
        </div>
        <!-- <template v-slot:modal-footer>
            <div class="d-flex justify-content-between w-100">
                <div class="">
                    <b-badge
                        v-if="showSuccess"
                        variant="success"
                        class="text-uppercase font-size-100 mr-4"
                        >Saved</b-badge>
                    <CancelButton @cancel="onCancel" />
                    <SaveButton :locked="loadingStart || showSuccess" @save="onSave" />
                </div>
            </div>
        </template> -->
    </b-modal>
</template>

<script>
import { errorHandling } from '../../../js/custom-vue-mixins';
import { suppliosApi } from '../../../js/api-service';
import LoadingContext from '../../shared/LoadingContext.vue';
import CancelButton from '../../shared/buttons/CancelButton.vue';
//import SaveButton from '../../shared/buttons/SaveButton.vue';
import SaveSuccess from '../../functional-comps/SaveSuccess.vue';
import cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'WorkflowStarter',
    components: {
        LoadingContext,
        CancelButton,
        //SaveButton,
        SaveSuccess,
    },
    mixins: [
        errorHandling,
    ],
    props: {
        specGroups: {
            type: [String, Array],
            required: true,
        },
        title: {
            type: String,
            default: 'Start a Workflow',
        },
        eager: {  // if true, we load the available options in mounted(), then emit to parent, so parent can use them to show what's available
            type: Boolean, 
            default: false, 
        },
        extraCreateData: {  // if you want to hard-code sending any data when calling 'create_run', pass it here
            // this overrides anything you have set in the form with same key
            type: Object,
            required: false,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loadingSpecOptions: false,
            loadingCreateSchema: false,
            loadingStart: false,
            optionsLoaded: false,  // flag to set when we've loaded options so we don't repeatedly load
            specOptions: [],  // get from API
            selectedSpec: null,  // once user picks one, goes here
            createSchema: null,  // the form schema for the create form of selected workflow spec
            createSchemaType: '',  // should be 'formulate' or others
            createData: {},  // v-model with formulate form data 
            mode: 'picker',  // switch between 'picker', 'form', ...
            isModalShown: false,
            showSuccess: false,
        }
    },
    computed: {
    },
    mounted() {
        // if eager, we'll load options now, otherwise in onShow()
        if (this.eager) {
            this.getSpecOptions();
        }
    },
    methods: {
        // PUBLIC METHODS - call from parents using $ref
        show(specId) {
            // show the modal, start the process
            // caller can OPTIONALLY pass the spec ID - IF THEY WERE ALREADY FETCHED - and it should automatically select that one
            if (specId && !!this.specOptions && Array.isArray(this.specOptions) && this.specOptions.length) {
                const foundSpec = this.specOptions.find(spec => (spec.id === specId));
                if (foundSpec) {
                    this.handleSpecSelection(foundSpec);
                }
            }
            this.isModalShown = true;
        },
        hide() {
            this.onHide();
        },
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getSpecOptions() {
            // fetch data needed for select boxes, and other 'setup' type data
            // combined eveything you need into one endpoint and make sure all select_related's are working so its fast
            this.loadingSpecOptions = true;
            try {
                const axiosConfig = {};
                if (this.specGroups) {
                    axiosConfig['params'] = {
                        spec_groups: this.specGroups,
                    };
                }
                const { data } = await suppliosApi.workflowSpec.list_for_create(axiosConfig);
                this.specOptions = data;
                this.optionsLoaded = true;  
                this.$emit('options-loaded', [...this.specOptions]);  // tell parent we have options and pass them up in case we load them eagerly and parent wants to list them or something...
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingSpecOptions = false;
        },
        async getCreateSchema() {
            const specId = this.selectedSpec.id;
            if (!specId) return;
            this.loadingCreateSchema = true;
            try {
                const { data } = await suppliosApi.workflowSpec.get_create_schema(specId);
                const { schema_type, components } = data;
                this.createSchemaType = schema_type;
                this.createSchema = components;  // array of formulate fields (if still using formulate)
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingCreateSchema = false;
        },
        handleSpecSelection(selectedSpec) {
            this.selectedSpec = Object.assign({}, selectedSpec);
            this.getCreateSchema();
            this.mode = 'form';
        },
        submitForm() {
            // programmatically call the submit handler on the form 
            // that will call whatever we have in @submit="" on FormulateForm
            // if there are any errors, the @submit handler will not get called, error messages will show
            this.$formulate.submit('createWorkflowRunForm');
        },
        async onSave(submitData) {
            // do the thing
            this.resetErrors();
            console.log(submitData);
            const specId = this.selectedSpec.id;
            if (!specId) return;
            this.loadingStart = true;
            const extraCreateData = this.extraCreateData ? cloneDeep(this.extraCreateData) : {};
            const finalCreateData = Object.assign(submitData, extraCreateData);
            try {
                const { data } = await suppliosApi.workflowSpec.create_run(specId, finalCreateData);
                console.log('Run Created!', data);
                // data is the serialized WorkflowRun instance -- we can get url from data.urls.internal_detail
                this.mode = 'success';
                const redirectUrl = data.urls.generic_redirect_url; 
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
            } catch (err) {
                this.apiErrorHandler(err, 'There was a problem trying to start this workflow.', true);
            }
            this.loadingStart = false;
        },
        onCancel() {
            this.onHide();
        },
        onBack() {
            // this starts over, but keeps modal open
            this.resetAll();
            this.getSpecOptions();
        },
        // onSuccess() {
        //     // clear any errors, showSuccess, onHide with timeout
        //     this.isFormValid = false;
        //     this.showErrors = false;
        //     this.showSuccess = true;
        //     setTimeout(() => {
        //         this.onHide();
        //     }, 1500);
        // },
        resetAll() {
            this.error = false;
            this.resetErrors();  // from mixin
            this.loadingSpecOptions = false;
            this.loadingCreateSchema = false;
            this.loadingStart = false;
            this.selectedSpec = null;
            this.createSchema = null;
            this.createSchemaType = '';
            this.createData = {};
            this.showSuccess = false;
            this.mode = 'picker';
            if (this.eager) {
                // if we set eager=true, we will not set optionsLoaded=false, so options will NOT be reloaded on show again
                // because most likely, the parent component is doing something with them 
            } else {
                // but if eager=false, then we must set optionsLoaded to false AND clear specOptions so they get re-fetched when we show again
                this.optionsLoaded = false;  
                this.specOptions = [];
            }
        },
        onHide() {
            this.isModalShown = false;
            // RESET EVERYTHING
            this.resetAll();
            this.$emit("hide");
        },
        // onHidden() {
        //     this.$emit("hidden");
        // },
        onShow() {
            if (!this.optionsLoaded) {
                // may have loaded them in mounted() if eager=true
                this.getSpecOptions();
            }
        },
    }
}
</script>

<style>

</style>